// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Obj {[key: string]: any}

/**
 * Utility function that filters an object returning a new object containing only
 * the specified keys of the original object.
 *
 * Usage:
 * import { filterObjectByKeys } from '@/lib/utils/filterObjectByKeys'
 *
 * @param obj The object to filter
 * @param keys The keys (property names) to retain
 */
// eslint-disable-next-line max-len, no-param-reassign
export const filterObjectByKeys = (obj: Obj, keys: string[]) => keys.reduce((result: Obj, k) => { result[k] = obj[k]; return result }, {})
